import React, { useState, useEffect } from "react";
import useLayoutEffect from "../../scripts/use-isomorphic-layout-effect";
import Layout from "../../components/layout";
import FormWrapper from "../../components/form-wrapper";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { removePrompt } from "../../scripts/auth-helper";
import { useRequestPasswordReset } from "../../components/hooks";
import { FormattedMessage, useIntl } from "react-intl";

const RequestPasswordReset = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { requestReset, loading, error } = useRequestPasswordReset();
  const [emailAddress, setEmailAddress] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const intl = useIntl();

  const handlePasswordReset = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    if (await requestReset(emailAddress)) {
      navigate(`/account/password-reset-link-sent${location.search}`, {
        state: { email: emailAddress },
      });
    }
  };

  useLayoutEffect(() => {
    setSubmitDisabled(emailAddress.length === 0);
  });

  useEffect(() => {
    const newUrl =
      location.pathname +
      removePrompt(location.search, "reset_password") +
      location.hash;
    navigate(newUrl, { replace: true, state: location.state });
  }, []);

  return (
    <Layout>
      <div id="passwordReset" className="container narrow">
        <h1 className="title is-3 mb-6">
          <FormattedMessage id="welcome" />
        </h1>
        {error && (
          <div className="notification is-danger is-light has-text-weight-bold has-text-centered">
            <FormattedMessage id={error} />
          </div>
        )}
        <FormWrapper>
          <h5 className="is-size-6 block">
            <FormattedMessage id="resetPasswordInstructions" />
          </h5>
          <form className="block" onSubmit={handlePasswordReset}>
            <div className="field">
              <div className="control">
                <input
                  className="login-input"
                  type="email"
                  placeholder={intl.formatMessage({ id: "emailAddress" })}
                  value={emailAddress}
                  onChange={(e) => setEmailAddress(e.target.value)}
                />
              </div>
            </div>
            <input
              className={
                "login-button is-primary is-medium " +
                (loading ? "is-loading" : "")
              }
              disabled={submitDisabled}
              type="submit"
              value={intl.formatMessage({ id: "sendEmail" })}
            />
          </form>
          <div className="is-flex">
            <Link
              className="is-link has-text-weight-bold is-size-6 mx-auto"
              to={`/account/login${location.search}`}
            >
              <FormattedMessage id="backToLogin" />
            </Link>
          </div>
        </FormWrapper>
      </div>
    </Layout>
  );
};

export default RequestPasswordReset;
